import { map } from 'ramda';

// finds error values in list of weeks and sets this and all remaining weeks to error state
export const checkSequence = (weeks) => {
	const incorrectWeeks = [];
	let currentWeek = null;

	for (const prop in weeks) {
		const nextWeek = weeks[prop];

		if (
			currentWeek &&
			(incorrectWeeks.length > 0 || Number(currentWeek.effectivity) > Number(nextWeek.effectivity))
		) {
			incorrectWeeks.push(nextWeek.weekId);
		}

		currentWeek = nextWeek;
	}

	return incorrectWeeks;
};

export const resetEffectivity = map((week) => ({ ...week, effectivity: 0 }));
